import React, { useEffect } from "react";

import Knowsomething from "./Knowsomething";
import image1 from "../../../assets/images/image2.png";
import image2 from "../../../assets/images/image3.png";
import image3 from "../../../assets/images/img4.png";
import savefuel from "../../../assets/images/Savefuel.png";
import easytouse from "../../../assets/images/easytouse.png";
import smsalert from "../../../assets/images/sms.png";
import easyonlinerecharge from "../../../assets/images/easyonlinericharge.png";
import Happy1 from "../../../assets/images/happy 1.png";
import jointline from "../../../assets/images/Vector 4.png";

import AOS from "aos";
import "aos/dist/aos.css";
import BelieveInNumbers from "./BelieveInNumbers";
import Services from "./Services";

const Whychooseus = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000, // Animation duration in milliseconds
      once: false,
      offset: 100, // Trigger when the element is 100px from the viewport
      delay: 200, // Whether animation should happen only once
    });
  }, []);
  return (
    <div className="tracking-wide -mt-12" id="whychooseus">
      <h1
        className="xl:text-5xl md:text-4xl text-3xl font-bold text-center mb-6 oxygen"
        data-aos="fade-up"
      >
        Why <span className="text-[#214293]">Choose</span> Us !
      </h1>
      <p
        className="text-center text-[#868686] lg:max-w-[80%] xl:max-w-[70%] md:max-w-[90%] max-w-[90%] md:mx-auto lg:mx-auto mx-auto mb-10  poppins xl:text-xl md:text-md lg:text-lg text-sm"
        data-aos="fade-up"
      >
        Drive Safe Solutions is the ideal option to travel without fuss on
        national highways, it facilitates automatic deduction of toll fees and
        allows you to pass through the toll plaza without stopping to pay in
        cash.
      </p>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-5 px-12">
        <div
          className="flex flex-col items-center p-6 lg:p-6 text-center space-y-2 bg-[#F1FAFF] hover:bg-[#E8F4FA] transform transition-transform duration-300"
          data-aos="flip-left"
        >
          <div className="p-3 bg-white md:mt-5 rounded-full">
            <img
              src={savefuel}
              alt="Professionally Managed"
              className="w-7 h-7 md:w-12 md:h-12"
            />
          </div>

          <h1 className="lg:text-2xl sm:text-base font-bold oxygen text-[#252525]">
            Save Fuel & Time
          </h1>
          <p className="text-sm md:text-base oxygen text-[#868686]">
            A FASTag, which operates on RFID, enhances your car journeys by
            saving both fuel and time.
          </p>
        </div>
        <div
          className="flex flex-col items-center p-6 lg:p-6 text-center space-y-2 bg-[#F1FAFF] hover:bg-[#E8F4FA] transform transition-transform duration-300"
          data-aos="flip-right"
        >
          <div className="p-3 bg-white rounded-full md:mt-5">
            <img
              src={easytouse}
              alt="Live Close"
              className="w-7 h-7 md:w-12 md:h-12"
            />
          </div>

          <h1 className="lg:text-2xl sm:text-base font-bold oxygen text-[#252525]">
            Ease to Use
          </h1>
          <p className="text-sm md:text-base oxygen text-[#868686]">
            Using a FASTag is as simple as sticking it to the inside of your
            car's windscreen.
          </p>
        </div>
        <div
          className="flex flex-col items-center p-6 lg:p-6 text-center space-y-2 bg-[#F1FAFF] hover:bg-[#E8F4FA] transform transition-transform duration-300"
          data-aos="zoom-in-up"
        >
          <div className="p-3 bg-white rounded-full md:mt-5">
            <img
              src={smsalert}
              alt="No Brokerage"
              className="w-7 h-7 md:w-12 md:h-12"
            />
          </div>

          <h1 className="lg:text-2xl sm:text-base font-bold oxygen text-[#252525]">
            Sms Alerts
          </h1>
          <p className="text-sm md:text-base oxygen text-[#868686]">
            An SMS containing the specifics of your transaction will be sent to
            the registered number.
          </p>
        </div>
        <div
          className="flex flex-col items-center p-6 lg:p-6 text-center space-y-2 bg-[#F1FAFF] hover:bg-[#E8F4FA] transform transition-transform duration-300"
          data-aos="zoom-in-down"
        >
          <div className="p-3 bg-white rounded-full md:mt-5">
            <img
              src={easyonlinerecharge}
              alt="Housing Professionals"
              className="w-7 h-7 md:w-12 md:h-12"
            />
          </div>

          <h1 className="lg:text-2xl sm:text-base font-bold oxygen text-[#252525]">
            Easy Online Recharge
          </h1>
          <p className="text-sm md:text-base oxygen text-[#868686]">
            Once activated, your FASTag can be connected to the bank or e-wallet
            of your choice, allowing you to manage and recharge it exclusively
            online
          </p>
        </div>
      </div>
      <Knowsomething />
      <BelieveInNumbers />
      <Services />

      {/* Section 1 */}
      <img
        src={jointline}
        alt=""
        className="absolute h-[880px] mt-36 ml-10 xl:block hidden "
        data-aos="zoom-out-right"
      />
      <div className="grid grid-cols-1 lg:grid-cols-4 gap-4 items-center xl:mt-16 lg:mt-12 mt-4">
        <div
          className="col-span-2 p-2 flex flex-col justify-center xl:gap-4 lg:gap-0 gap-3 h-full md:pl-16"
          data-aos="fade-right"
        >
          {" "}
          <div className="flex justify-start items-center gap-4 lg:pl-3">
            <div className="rounded-full bg-[#007DFE] md:p-3 p-2">
              <img src={Happy1} alt="" className="md:h-7 md:w-7 h-4 w-4" />
            </div>
            <h2 className="md:text-2xl lg:text-3xl text-2xl font-bold text-gray-900 mb-4 md:mt-6 lg:mt-2 mt-2 oxygen">
              M2P FINTECH "<span className="text-[#F26422]">LIVQUIK</span>"
            </h2>
          </div>
          <p className="text-[#868686] xl:text-[1.1rem] text-sm md:max-w-[95%] poppins xl:leading-relaxed lg:leading-normal oxygen pl-10 md:pl-16 lg:pl-20">
            Drivesafe Sollutionprefers partner assurance of M2P FINTECH which is
            one of the largest fintech API Provider. It Includes big players
            like Bajaj Finance which is the largest WBFC of India, Cashfree
            Payments considered to be the leader of Payer API.
          </p>
          <p className="text-[#868686] xl:text-[1.1rem] text-sm md:max-w-[95%] poppins xl:leading-relaxed lg:leading-normal pl-10 md:pl-16 lg:pl-20">
            By bridging traditional financial services with modern technology,
            M2P Fintech empowers businesses to create customized financial
            products, enhance customer experiences, and scale their operations
            efficiently. Its robust APIs and technology-driven approach make it
            a key player in the rapidly evolving fintech ecosystem.
          </p>
        </div>
        <div className="flex justify-center items-center col-span-2  hover:scale-105 transform transition-transform duration-300 pl-4 lg:pl-0">
          <img
            alt="Live"
            src={image1}
            className="col-span-2 w-[80%] md:h-[400px] lg:h-auto h-auto hover:scale-105 transform transition-transform duration-300"
            data-aos="fade-left"
          />
        </div>
      </div>

      {/* Section 2 */}
      <div className="grid grid-cols-1 lg:grid-cols-4 items-center xl:mt-16 lg:mt-12 mt-4">
        <div className="flex justify-center items-center col-span-2  hover:scale-105 transform transition-transform duration-300 pl-4 lg:pl-0">
          <img
            alt="Live"
            src={image2}
            className="col-span-2 w-[80%] md:h-[400px] lg:h-auto h-auto hover:scale-105 transform transition-transform duration-300"
            data-aos="fade-left"
          />
        </div>

        <div
          className="col-span-2 p-6 lg:rounded-l-[5rem] flex flex-col justify-center h-full md:pl-16 lg:pl-0 pl-7 "
          data-aos="fade-left"
        >
          <div className="flex justify-start items-center gap-4 lg:pl-3">
            <div className="rounded-full bg-[#FFC801] md:p-3 p-2">
              <img src={Happy1} alt="" className="md:h-7 md:w-7 h-4 w-4" />
            </div>
            <h2 className="md:text-2xl lg:text-3xl text-2xl font-bold text-gray-900 mb-4 md:mt-6 lg:mt-2 xl:mt-6 mt-2 oxygen">
              IDFC First bank Fast tag
            </h2>
          </div>
          <p className="text-[#868686] xl:text-[1.1rem] text-sm md:max-w-[95%] poppins xl:mt-5 mt-0 xl:leading-relaxed lg:leading-normal pl-10 md:pl-16 lg:pl-20">
            Introducing the next evolution in toll payments - FASTag bundled
            with MAX benefits that offers a range of benefits to make road trips
            safer and more hassle-free.
          </p>
          <p className="text-[#868686] xl:text-[1.1rem] text-sm md:max-w-[95%] poppins xl:mt-5 mt-0 xl:leading-relaxed lg:leading-normal pl-10 md:pl-16 lg:pl-20">
            Make way for smoother and faster highway rides with FASTag by IDFC
            FIRST Bank. No more queuing up or waiting for change at toll plazas.
            In addition to paying tolls, you can use your IDFC FIRST Bank FASTag
            to pay for your parking and fuel purchases. Recharge online using
            the FIRSTforward mobile app and unlock convenience and savings on
            your next road trip.
          </p>
        </div>
        <div className="flex justify-center items-center col-span-2 hover:scale-105 transform transition-transform duration-300 pl-4 lg:pl-0">
          <img
            alt="Live"
            src={image2}
            className="col-span-2 mx-auto w-[85%] hover:hidden transform transition-transform duration-300 block lg:hidden"
            data-aos="fade-right "
          />
        </div>
      </div>

      {/* Section 3 */}
      <div className="grid grid-cols-1 lg:grid-cols-5 gap-4 items-center xl:mt-16 lg:mt-12 my-4">
        <div
          className="col-span-3 p-2 flex flex-col justify-center xl:gap-4 lg:gap-0 gap-3 h-full md:pl-16"
          data-aos="fade-right"
        >
          <div className="flex justify-start items-center gap-4 lg:pl-3">
            <div className="rounded-full bg-[#9208D3] md:p-3 p-2">
              <img src={Happy1} alt="" className="md:h-7 md:w-7 h-4 w-4" />
            </div>
            <h2 className="md:text-2xl lg:text-3xl text-2xl font-bold text-gray-900 mb-4 md:mt-6 lg:mt-2 mt-2 oxygen">
              Bajaj Finance
            </h2>
          </div>
          <p className="text-[#868686] xl:text-[1.1rem] text-sm md:max-w-[95%] poppins xl:leading-relaxed lg:leading-normal oxygen pl-10 md:pl-16 lg:pl-20">
            Bajaj Pay FASTag is an electronic toll collection system introduced
            by Bajaj Finserv in India. It is a passive RFID (Radio Frequency
            Identification) tag affixed to the windshield of a vehicle, enabling
            automatic toll payments at highway toll plazas.
          </p>
          <p className="text-[#868686] xl:text-[1.1rem] text-sm md:max-w-[95%] poppins xl:leading-relaxed lg:leading-normal pl-10 md:pl-16 lg:pl-20">
            This contactless payment method significantly reduces travel time
            and congestion, as vehicles can pass through toll booths without
            stopping. Users can link their FASTag to their Bajaj Pay Wallet,
            ensuring seamless transactions and avoiding the need to carry cash.
            The Bajaj Pay FASTag offers a convenient and efficient way for
            commuters to enjoy a hassle-free journey on national highways and
            select city toll plazas.
          </p>
        </div>
        <div className="flex justify-center items-center col-span-2  hover:scale-105 transform transition-transform duration-300 pl-4 lg:pl-0">
          <img
            alt="Live"
            src={image3}
            className="col-span-2 w-[80%] md:h-[400px] lg:h-auto h-auto hover:scale-105 transform transition-transform duration-300"
            data-aos="fade-left"
          />
        </div>
      </div>
    </div>
  );
};

export default Whychooseus;
